import { takeLatest, all, put } from 'redux-saga/effects';
import { Actions } from '../action';
import { doGet, doPost } from '../../config';
import { ResponseGenerator } from './SagaInterface';
import END_POINTS from '../../config/Endpoints';
import { TROUBLE_SHOOT_LIST } from '../action/TroubleShootAction';
export function* TroubleShootListSaga(param: any) {
    const { params, callback } = param
    try {
        const response: ResponseGenerator = yield doGet(END_POINTS.TROUBLE_SHOOT_LIST, params, '')
        yield put(Actions.troubleShootListSuccess(response));
        callback && callback(response)
    } catch (error) {
        yield put(Actions.troubleShootListFailure({ error }));
        callback && callback({ error })
    }
}
export default function* troubleShootWatcher() {
    yield all([
        takeLatest(TROUBLE_SHOOT_LIST, TroubleShootListSaga),
    ]);
}
